import React from 'react'
import { Link } from 'react-router-dom'
import { Menu } from 'antd'
import { useParams } from 'react-router-dom'

import { BarcodeOutlined, CopyOutlined, DiffOutlined } from '@ant-design/icons'

const AdvanceFeatureSidebar = () => {
  const { slug, id } = useParams()
  return (
    <>
      <Menu
        data-testid='sidebar-component'
        style={{
          padding: '48px 24px'
        }}
      >
        <Menu.Item key='general'>
          <BarcodeOutlined />
          <Link to={`/product/${slug}/${id}/edit/general`}>General</Link>
        </Menu.Item>
        <Menu.Item key='product-variants'>
          <CopyOutlined />
          <Link to={`/product/${slug}/${id}/edit/variants`}>Variants</Link>
        </Menu.Item>
        <Menu.Item key='modifiers'>
          <DiffOutlined />
          <Link to={`/product/${slug}/${id}/edit/modifiers`}>Modifiers</Link>
        </Menu.Item>
      </Menu>
    </>
  )
}

export default AdvanceFeatureSidebar
